import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=992699da&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=ts&"
export * from "./Edit.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=992699da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992699da",
  null
  
)

export default component.exports